export default "__VITE_ASSET__0eeZsvEB__"